import { Link, Popover } from '@amzn/awsui-components-react'
import React from 'react'

const WILDCARD_CHARACTER = "*"
const WILDCARD_WIKI_LINK = "https://w.amazon.com/bin/view/NetworkTopologyModeling/AMOS/DNC/RuleGroupConfiguration/#HWildcards"
const WILDCARD_MESSAGE = <Link href={WILDCARD_WIKI_LINK}>Learn More</Link>

export const WildcardPopover: React.FC = ({children}) => {
  return (
    <Popover header={"Wildcard Value"} content={WILDCARD_MESSAGE}>{children}</Popover>
  )
}

export const isWildcard = (value: string): boolean => value.includes(WILDCARD_CHARACTER)